export const SAVE_INTERACTIONS = 'SAVE_INTERACTIONS';
export const SET_WHOLE_INTERACTIONS = 'SET_WHOLE_INTERACTIONS';
